import TabsList from './TabsList'
export default TabsList
